import { apolloClientInstance, normalize } from 'gatsby-theme-apollo';
import { gql } from '@apollo/client';
import uniqid from 'uniqid';

const getUniqueTierListPermalink = async ({ gameID, title }) => {
  const permalink = normalize.hyphenateAndLowerCase(title);
  const slug = uniqid.time();

  const permalinkResult = await apolloClientInstance
    .query({
      query: gql`
          {
            tierlists(where: {permalink_eq: "${permalink}"}){
              permalink
              title
              id
            }
          }
          `
    })
    .then(result => {
      if (!result.data || !result.data || !result.data.tierlists) {
        return permalink;
      }
      const { tierlists } = result.data;
      if (tierlists && tierlists.length >= 1) {
        // there is a collision, so append unique hash 
        return permalink + '_' + slug;
      }
      return permalink;
    })
    .catch(error => {
      console.error("getUniqueTierListPermalink FAILED", error);
      return permalink;
    });

  return {permalinkResult, slug};
};

const getAuthorTierLists = async ({ authorID }) => {
  if (!authorID) {
    console.error(`Unable to retireve Tier Lists for Author. Missing ID`);
  }
  const tierListQueryResult = await apolloClientInstance
    .query({
      query: gql`
        {
          tierlists(where: { author_eq: "${authorID}" }, sort:"createdAt:DESC") {
            id
            title
            tierJSON
            description
            updatedAt
            permalink
            lastPublish
            createdAt
            author {
              name
              id
            }
            game {
              name
              id
              updatedAt
            }
          }
        }
      `
    })
    .then(result => {
      if (!result.data || !result.data || !result.data.tierlists) {
        return false;
      }
      const { tierlists } = result.data;
      return tierlists;
    })
    .catch(error => {
      console.error(`Somethin went wrong retrieving posts for author with ID ${authorID}`);
      console.error(error);
      return false;
    });

  return tierListQueryResult;
};

export { getAuthorTierLists, getUniqueTierListPermalink };
